'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _safeToBn = require('../utilities/safeToBn');

var _safeToBn2 = _interopRequireDefault(_safeToBn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noopCache = { get: function get() {
    return null;
  }, set: function set() {
    return null;
  } };

/**
 * Responsible for all anonymous operations against the eth network
 */

var Eth = function () {
  /**
   * Constructor
   *
   * @param {Object} web3Eth
   * @param {Object} cache
   */
  function Eth(web3Eth) {
    var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noopCache;

    _classCallCheck(this, Eth);

    this.web3Eth = web3Eth;
    this.cache = cache;
  }

  /**
   * Fetches the balance for a given address
   *
   * @param {String} address
   *
   * @return {Promise<BN>} balance in wei
   */


  _createClass(Eth, [{
    key: 'fetchBalance',
    value: function fetchBalance(address) {
      return this.web3Eth.getBalance(address).then(function (balance) {
        return (0, _safeToBn2.default)(balance);
      });
    }

    /**
     * Fetches an array of transaction receipts.
     *
     * {@link https://web3js.readthedocs.io/en/1.0/web3-eth.html#gettransactionreceipt}
     *
     * @param {String[]} transactionHashes
     *
     * @return {Promise<Object[]>}
     */

  }, {
    key: 'fetchTransactionReceipts',
    value: function fetchTransactionReceipts(transactionHashes) {
      var _this = this;

      var getReceipt = function getReceipt(txHash) {
        return _this.web3Eth.getTransactionReceipt(txHash);
      };
      return Promise.all(transactionHashes.map(getReceipt)).then(function (transactions) {
        return transactions.filter(function (receipt) {
          return receipt;
        });
      });
    }

    /**
     * Fetches an array of transactions.
     *
     * {@link https://web3js.readthedocs.io/en/1.0/web3-eth.html#gettransaction}
     *
     * @param {String[]} transactionHashes
     *
     * @return {Promise<Object[]>}
     */

  }, {
    key: 'fetchTransactions',
    value: function fetchTransactions(transactionHashes) {
      var _this2 = this;

      var getTransaction = function getTransaction(txHash) {
        return _this2.web3Eth.getTransaction(txHash);
      };
      return Promise.all(transactionHashes.map(getTransaction)).then(function (transactions) {
        return transactions.filter(function (transaction) {
          return transaction;
        });
      });
    }

    /**
     * Fetches an array of blocks
     * Because blocks are immutable, we cache them aggressively
     *
     * @param {Number[]} blockNumbers
     *
     * @return {Promise<Object[]>}
     */

  }, {
    key: 'fetchBlocks',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(blockNumbers) {
        var _this3 = this;

        var cachedBlocks, _partition, _partition2, cachedNumbers, fetchNumbers, fetchedNumbers;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cachedBlocks = this.cache.get('blocks') || [];
                _partition = (0, _lodash.partition)(blockNumbers, function (num) {
                  return cachedBlocks[num];
                }), _partition2 = _slicedToArray(_partition, 2), cachedNumbers = _partition2[0], fetchNumbers = _partition2[1];
                _context.next = 4;
                return Promise.all(fetchNumbers.map(function (num) {
                  return _this3.web3Eth.getBlock(num);
                }));

              case 4:
                fetchedNumbers = _context.sent;


                // update cache when it changes
                if (fetchNumbers.length) {
                  this.cache.set('blocks', _extends({}, cachedBlocks, fetchedNumbers.reduce(function (out, block) {
                    return _extends({}, out, _defineProperty({}, block.number, {
                      blockNumber: block.number,
                      timestamp: block.timestamp
                    }));
                  }, {})));
                }

                // satisfy request
                return _context.abrupt('return', cachedNumbers.map(function (num) {
                  return cachedBlocks[num];
                }).concat(fetchedNumbers.map(function (block) {
                  return {
                    blockNumber: block.number,
                    timestamp: block.timestamp
                  };
                })));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchBlocks(_x2) {
        return _ref.apply(this, arguments);
      }

      return fetchBlocks;
    }()

    /**
     * Fetches the code for a given address
     *
     * @param {String} address
     *
     * @return {Promise<String>}
     */

  }, {
    key: 'fetchCode',
    value: function fetchCode(address) {
      return this.web3Eth.getCode(address);
    }

    /**
     * Checks if a given address is a contract.
     *
     * @param {String} address
     *
     * @return {Promise<Bool>}
     */

  }, {
    key: 'isAddressValidContract',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(address) {
        var bytecode;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetchCode(address);

              case 2:
                bytecode = _context2.sent;

                if (!(!bytecode || bytecode === '0x')) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt('return', false);

              case 5:
                return _context2.abrupt('return', true);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function isAddressValidContract(_x3) {
        return _ref2.apply(this, arguments);
      }

      return isAddressValidContract;
    }()
  }, {
    key: 'fetchLatestBlockNumber',
    value: function fetchLatestBlockNumber() {
      return this.web3Eth.getBlockNumber();
    }
  }]);

  return Eth;
}();

exports.default = Eth;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/services/Eth.js
// module id = 1229
// module chunks = 0